export default "__VITE_ASSET__cHaZFEOm__"